/**
 * Sticky Add to Cart JS
 * Handles the visibility of the sticky bar using IntersectionObserver
 */

if (!customElements.get('sticky-add-to-cart')) {
    class StickyAddToCart extends HTMLElement {
        constructor() {
            super();
        }

        connectedCallback() {
            console.log('StickyAddToCart: connected');
            this.sectionId = this.dataset.section;
            this.primaryButton = document.querySelector(`#product-form-${this.sectionId} [name="add"]`);

            if (!this.primaryButton) {
                this.primaryButton = document.querySelector('button[name="add"]');
            }

            console.log('StickyAddToCart: primaryButton found:', !!this.primaryButton);

            if (this.primaryButton) {
                this.initObserver();
            }
        }

        initObserver() {
            const observerOptions = {
                root: null,
                threshold: 0,
                rootMargin: '0px 0px 0px 0px'
            };

            this.observer = new IntersectionObserver((entries) => {
                entries.forEach((entry) => {
                    // Show only if the button is ABOVE the viewport (scrolled past it)
                    const isAboveViewport = entry.boundingClientRect.top < 0;

                    if (!entry.isIntersecting && isAboveViewport) {
                        console.log('StickyAddToCart: Setting active state');
                        requestAnimationFrame(() => {
                            this.classList.add('is-visible');
                            document.documentElement.classList.add('sticky-add-to-cart-is-active');
                            document.body.classList.add('sticky-add-to-cart-is-active');
                        });
                    } else {
                        console.log('StickyAddToCart: Removing active state');
                        requestAnimationFrame(() => {
                            this.classList.remove('is-visible');
                            document.documentElement.classList.remove('sticky-add-to-cart-is-active');
                            document.body.classList.remove('sticky-add-to-cart-is-active');
                        });
                    }
                });
            }, observerOptions);

            this.observer.observe(this.primaryButton);
        }

        disconnectedCallback() {
            if (this.observer) {
                this.observer.disconnect();
            }
        }
    }

    customElements.define('sticky-add-to-cart', StickyAddToCart);
}
